import { atom } from 'jotai';

import { Maybe } from '@/types';
import { SvgCamiseta, SvgEscudo } from '@/types/editProfile';

export type TshitAndShieldTypes = {
  shield: SvgEscudo;
  tshirt: SvgCamiseta;
};

/** camiseta.param5 (nroSponsor) correspondiente a BetWarrior. */
export const tshirtSponsor = {
  betwarrior: '2',
  clarin: '4',
  ole: '1',
  tn: '3',
  noSponsor: undefined,
};

export const defaultShieldTeam = {
  escudoparam1: '',
  escudoparam2: '31',
  escudoparam3: 'dddddd',
  escudoparam4: 'ffffff',
  escudoparam5: '',
};

export const defaultTshirtTeam = {
  param1: '1',
  param2: '31',
  param3: 'ffffff',
  param4: 'dddddd',
  param5: undefined,
};

export const initialTshitAndShield: TshitAndShieldTypes = {
  shield: defaultShieldTeam as SvgEscudo,
  tshirt: defaultTshirtTeam as SvgCamiseta,
};

export const tshirtAndShieldAtom = atom<Maybe<TshitAndShieldTypes>>(
  initialTshitAndShield
);
